import React from "react";
import { WangramIcon } from "./WangramLogo";

/**
 * Full-screen "under construction" splash shown to everyone except the admin
 * while the site is paused. Deliberately uses the same emerald + grain
 * aesthetic as the auth shell so it still feels like wangram, not a 503.
 */
export default function MaintenanceSplash() {
  return (
    <div
      className="min-h-screen w-full relative flex items-center justify-center px-4 overflow-hidden bg-[#0A0D0B] text-white"
      data-testid="maintenance-splash"
      role="status"
      aria-live="polite"
    >
      {/* Watermark */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
        <WangramIcon
          className="w-[min(90vw,860px)] h-[min(90vw,860px)] opacity-[0.05]"
          ariaLabel=""
        />
      </div>

      {/* Radial glow */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: "radial-gradient(600px 400px at 50% 40%, rgba(42,219,128,0.14), transparent 70%)",
        }}
      />

      {/* Subtle scanning line */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-[#2ADB80]/40 to-transparent animate-maintenance-scan" />

      <div className="relative z-10 text-center max-w-xl">
        <div className="flex items-center justify-center mb-8">
          <WangramIcon
            className="w-28 h-28 md:w-36 md:h-36 rounded-2xl drop-shadow-[0_12px_60px_rgba(42,219,128,0.4)] animate-maintenance-float"
            ariaLabel="wangram"
          />
        </div>

        <div className="label-eyebrow mb-3 text-[#2ADB80]/80">
          wangram<span className="text-white/40">.com</span>
        </div>
        <h1 className="font-display font-black tracking-tight text-4xl md:text-6xl leading-[1.05] mb-5">
          Under construction
        </h1>
        <p className="text-[14px] md:text-[15px] text-white/60 leading-relaxed max-w-md mx-auto mb-10">
          We're polishing a few things. The 5-model comparison, your sessions and your coins are all safe —
          this page comes right back as soon as we're done.
        </p>

        {/* Animated dot row */}
        <div className="flex items-center justify-center gap-2" aria-hidden="true">
          <span className="w-2 h-2 rounded-full bg-[#2ADB80] animate-maintenance-dot" style={{ animationDelay: "0ms" }} />
          <span className="w-2 h-2 rounded-full bg-[#2ADB80]/70 animate-maintenance-dot" style={{ animationDelay: "180ms" }} />
          <span className="w-2 h-2 rounded-full bg-[#2ADB80]/40 animate-maintenance-dot" style={{ animationDelay: "360ms" }} />
        </div>

        <div className="mt-12 label-eyebrow opacity-50">
          see further · soon
        </div>
      </div>
    </div>
  );
}
